import { call, put, takeLatest } from 'redux-saga/effects';
import { PostTopics } from 'services/api';
import {
  getPostTopics,
  getPostTopicsSuccess,
  getPostTopicsFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getPostTopicsSaga() {
  try {
    const data = yield call(PostTopics.getPostTopics);
    yield put(getPostTopicsSuccess(data));
  } catch (e) {
    yield put(getPostTopicsFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(getPostTopics, getPostTopicsSaga);
